import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlAgFieldsFragment = { companyId: string, contactId?: string | null, createdAt: string, id: string, noBoardStatement: boolean, primaryLang: boolean, secondaryLang: boolean, signatoryId?: string | null, snrAuthorizationId?: string | null, snrCaseId?: string | null, updatedAt: string, validThruAgmYear?: string | null, validThruDate?: string | null, regFormPaymentThroughBolago: boolean, maxNumberOfShares: number, otherIncreasesOfShares: number, requiresShareLimitChange: boolean };

export const AgFieldsFragmentDoc = gql`
    fragment AgFields on AuthorizationGroup {
  companyId
  contactId
  createdAt
  id
  noBoardStatement
  primaryLang
  secondaryLang
  signatoryId
  snrAuthorizationId
  snrCaseId
  updatedAt
  validThruAgmYear
  validThruDate
  regFormPaymentThroughBolago
  maxNumberOfShares
  otherIncreasesOfShares
  requiresShareLimitChange
}
    `;